var React = require('react');
var ReactDOM = require('react-dom');
var {Route, Router, IndexRoute,  Link,hashHistory, browserHistory} = require('react-router');

var Main = require('Main');
var Login = require('Login');
var Categories = require('Categories');
import App from 'react/app/components/App';

ReactDOM.render(
	<Router history={hashHistory}>
		<Route path="/" component={Main}>
			<IndexRoute component={Login}/>
			<Route  path="categories" component={Categories} />
			<Route  path="quiz" component={App} />
		</Route>
		
	</Router>,
	document.getElementById('app')
	);


// WEBPACK FOOTER //
// ./react/app/app.jsx